import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import TeamsOverview from './TeamsOverview';
import Hero from './Hero';
import CorePrinciples from './CorePrinciples';
import CoreTeam from './CoreTeam';
import CoreWorkflow from './CoreWorkflow';
import AISection from './AISection';
import OKRSection from './OKRSection';
import TeamDeliveryRocket from './TeamDeliveryRocket';
import './Home.css';

function Home() {
  const [activeTab, setActiveTab] = useState('principles');
  const [searchParams] = useSearchParams();
  const tabsRef = useRef(null);

  useEffect(() => {
    const tabParam = searchParams.get('tab');

    // Only update if it's a valid tab
    if (['principles', 'team', 'workflow'].includes(tabParam)) {
      setActiveTab(tabParam);
      tabsRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [searchParams]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    tabsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'principles':
        return <CorePrinciples />;
      case 'team':
        return <CoreTeam />;
      case 'workflow':
        return <CoreWorkflow />;
      default:
        return <CorePrinciples />;
    }
  };

  return (
    <div>
        <div className="blue20-background">
            <Hero />
        </div>
        <div className="container">
          <div ref={tabsRef} className="tabs left-aligned-tabs">
            <button onClick={() => handleTabClick('principles')} className={activeTab === 'principles' ? 'active' : ''}>1. Core Principles</button>
            <button onClick={() => handleTabClick('team')} className={activeTab === 'team' ? 'active' : ''}>2. Core Team</button>
            <button onClick={() => handleTabClick('workflow')} className={activeTab === 'workflow' ? 'active' : ''}>3. Core Workflow</button>
          </div>
        </div>
        {renderActiveTab()}

        <div id="our-teams" className="blue20-background">
          <TeamsOverview />
        </div>
        <div>
          <TeamDeliveryRocket />
        </div>
        <div style={{ backgroundColor: '#f2f4fe' }}>
          <AISection />
        </div>
        <div>
          <OKRSection />
        </div>
    </div>
  );
}

export default Home;
